import axios from "axios";
import * as AppSettingsService from "./AppSettingsService";

const appSettings = AppSettingsService;

export async function getPersonSummary(personId?: number): Promise<any> {
  try {
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/personorg/person/v1/summary`,
      {
        headers: { "x-personId": personId },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export function base64ToBlob(base64File: string, fileType: string) {
  const binaryString = window.atob(base64File);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return new Blob([bytes], { type: fileType });
}
